import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendChatMessage as SendChatMessageMutation,
    SendChatMessageVariables as SendChatMessageMutationVariables,
    MessageSendForChatInput,
} from 'nutshell-graphql-types';

import SEND_CHAT_MESSAGE from '../mutations/send-chat-message.graphql';

export const useSendChatMessage = (): {
    sendChatMessage: (input: MessageSendForChatInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [messageSendForChat, {loading, error}] = useMutation<
        SendChatMessageMutation,
        SendChatMessageMutationVariables
    >(SEND_CHAT_MESSAGE);

    return {
        sendChatMessage: (input: MessageSendForChatInput) => {
            return messageSendForChat({
                variables: {input},
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
